import { render, staticRenderFns } from "./CommonRectificatDetails.vue?vue&type=template&id=96876a9a&scoped=true"
import script from "./CommonRectificatDetails.vue?vue&type=script&lang=js"
export * from "./CommonRectificatDetails.vue?vue&type=script&lang=js"
import style0 from "./CommonRectificatDetails.vue?vue&type=style&index=0&id=96876a9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96876a9a",
  null
  
)

export default component.exports